import React from "react";
import { Grid, InputAdornment, TextField, Typography } from "@material-ui/core";
import AuthorizationWrapper from "../AuthorizationWrapper";
import GetCurrency from "../../helper/GetCurrency";

function AmountSetting(props) {
  const transformedValue = typeof props.setting.value === "number" ? (props.setting.value / 100.0).toFixed(2) : "";
  const [value, setValue] = React.useState(transformedValue);
  return (
    <AuthorizationWrapper
      permission={props.authenticationName}
      child={(write) => {
        return (
          <>
            <Grid container alignItems={"center"} spacing={1}>
              <Grid item xs={2}>
                <TextField
                  disabled={!write}
                  value={value}
                  type={"number"}
                  onChange={(e) => setValue(e.target.value)}
                  onBlur={() => {
                    props.onChange(Math.round(value * 100));
                  }}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">{GetCurrency()}</InputAdornment>,
                  }}
                />
              </Grid>
              <Grid item xs={10}>
                <Typography>{props.label}</Typography>
              </Grid>
            </Grid>
            {props.children}
          </>
        );
      }}
    />
  );
}

export default AmountSetting;
